/**
 * Copyright © 2026 OwnersTable Inc. All rights reserved.
 * This source code is proprietary and confidential.
 * Unauthorized copying or distribution is strictly prohibited.
 */

import api from "../../../api";

export const DAILY_LOGBOOK_INDEX_PATH = "/v1/admin/daily_logbooks";

/**
 * Fetches the index payload, returning the axios-shaped `{ data, headers }`.
 */
export const fetchDailyLogbookIndex = (params) => api.get(DAILY_LOGBOOK_INDEX_PATH, { params });

/**
 * Fetches one restaurant broken out by revenue center, with the four sections at both
 * grains. 404 means the id is unknown or outside the admin's scope.
 */
export const fetchDailyLogbookDetail = (restaurantId, params) =>
  api.get(`${DAILY_LOGBOOK_INDEX_PATH}/${restaurantId}`, { params });
